<!--
  @copyright 汽车商贸管理平台 V1.0
  @year 2026
  @description App
-->
<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "app",
  components: {},
};
</script>

<style lang="less">
#app {
  background-color: #f5f5f5; /* 调整为更浅的灰色背景 */
  /*   div {
    padding: 0;
    margin: 0;    
  } */
  height: 100vh;
}
/* 适用于移动设备的样式 */
@media screen and (max-width: 768px) {
  /* 在这里定义移动端的样式 */
  body {
    font-size: 16px; /* 假设在移动端使用16px的基础字体大小 */
  }
  /* ... 其他移动端样式 ... */
}

/* 适用于电脑设备的样式 */
@media screen and (min-width: 769px) {
  /* 在这里定义电脑端的样式 */
  body {
    font-size: 18px; /* 假设在电脑端使用18px的基础字体大小 */
  }
  /* ... 其他电脑端样式 ... */
}
</style>
